// before 20-5-2026


// import React, { useEffect, useState } from 'react';
// import { ChannelActions } from './ChannelActions';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
// import Table from 'react-bootstrap/esm/Table';
// import { Snackbar, Alert, useMediaQuery, TextField, Box, MenuItem } from '@mui/material';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { Col, Container, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import AddIcon from '@mui/icons-material/Add';
// import moment from 'moment';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import FilterListIcon from '@mui/icons-material/FilterList';

// export const ChannelTable = () => {
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   const [loading, setloading] = useState(true);
//   const dispatch = useDispatch();

//   // States for filtering
//   const [searchTerm, setSearchTerm] = useState('');
//   const [codeFilter, setCodeFilter] = useState('all');

//   const run = async () => {
//     setloading(true);
//     await dispatch(GetAllchannalData());
//     setloading(false);
//   };

//   useEffect(() => {
//     run();
//   }, [dispatch]);

//   const res_Get_All = useSelector((state) => state.AllChannalRoot.channal);
//   let res_get_array = Array.isArray(res_Get_All?.data) ? res_Get_All.data : [];

//   // Filtered channels based on search and filters
//   const filteredChannels = res_get_array.filter((channel) => {
//     const matchesSearch =
//       channel.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       channel.code?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesCode =
//       codeFilter === 'all' || channel.code?.toLowerCase().includes(codeFilter.toLowerCase());

//     return matchesSearch && matchesCode;
//   });

//   // Get unique codes for filter dropdown
//   const uniqueCodes = [
//     ...new Set(res_get_array.map((channel) => channel.code).filter((code) => code)),
//   ];

//   //clipboard copy channal id
//   const [open, setOpen] = useState(false);
//   const handleCopy = () => {
//     setOpen(true);
//     setTimeout(() => setOpen(false), 2000);
//   };

//   // تحديد المسار المناسب بناءً على الدور
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeadsForAdmin'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer'
//         : '/'; // fallback

//   const [columns, setColumns] = useState([
//     { key: 'copyId', label: 'Copy Id', visible: true, width: 100 },
//     { key: 'name', label: 'Channel Name', visible: true, width: 150 },
//     { key: 'code', label: 'Code', visible: true, width: 100 },
//     { key: 'date', label: 'Creation Date', visible: true, width: 180 },
//     { key: 'actions', label: '', visible: true, width: 120 },
//   ]);

//   const startResizing = (e, colIndex) => {
//     const startX = e.clientX;
//     const startWidth = columns[colIndex].width;

//     const doDrag = (moveEvent) => {
//       const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
//       const newCols = [...columns];
//       newCols[colIndex].width = newWidth;
//       setColumns(newCols);
//     };

//     const stopDrag = () => {
//       document.removeEventListener('mousemove', doDrag);
//       document.removeEventListener('mouseup', stopDrag);
//     };

//     document.addEventListener('mousemove', doDrag);
//     document.addEventListener('mouseup', stopDrag);
//   };

//   // Clear all filters
//   const clearFilters = () => {
//     setSearchTerm('');
//     setCodeFilter('all');
//   };

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           <div className="d-flex justify-content-between flex-wrap">
//             <div>
//               <div>
//                 <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                   <span style={{ fontWeight: 'bold' }}>Home</span>
//                 </Link>
//                 <KeyboardDoubleArrowRightIcon />
//                 <span style={{ color: '#666' }}>Home Channel</span>
//               </div>
//             </div>
//           </div>

//           <div className="w-100 d-flex justify-content-end">
//             <Link to={`/channal/addchannal`} style={{ textDecoration: 'none' }}>
//               <div
//                 className="public-color btn btn-success icon-plus addnewclientbtn  my-2"
//                 style={{ background: '#102dff' }}
//               >
//                 <AddIcon /> Add New Channel
//               </div>
//             </Link>
//           </div>

//           {/* 🔍 Filter Section */}
//           <Box
//             sx={{
//               mb: 3,
//               p: 2,
//               border: `1px solid ${mode === 'dark' ? '#444' : '#ddd'}`,
//               borderRadius: 2,
//               backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f9f9f9',
//             }}
//           >
//             <div className="d-flex align-items-center mb-2">
//               <FilterListIcon sx={{ mr: 1, color: '#102dff' }} />
//               <h6 style={{ margin: 0, color: mode === 'dark' ? '#90caf9' : '#666' }}>
//                 Filter Channels
//               </h6>
//             </div>

//             <div className="row g-2">
//               <div className="col-md-5">
//                 <TextField
//                   fullWidth
//                   size="small"
//                   placeholder="Search by name or code..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: '#666', mr: 1 }} />,
//                   }}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                     },
//                   }}
//                 />
//               </div>

//               <div className="col-md-4">
//                 <TextField
//                   select
//                   fullWidth
//                   size="small"
//                   label="Filter by Code"
//                   value={codeFilter}
//                   onChange={(e) => setCodeFilter(e.target.value)}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                     },
//                   }}
//                 >
//                   <MenuItem value="all">All Codes</MenuItem>
//                   {uniqueCodes.map((code) => (
//                     <MenuItem key={code} value={code}>
//                       {code}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </div>

//               <div className="col-md-3">
//                 <div className="d-flex gap-2">
//                   <button
//                     className="btn btn-outline-secondary"
//                     onClick={clearFilters}
//                     style={{ width: '100px', height: '40px', background: '#102dff', color: '#fff' }}
//                   >
//                     Clear
//                   </button>

//                   {/* Results count */}
//                   <div className="d-flex align-items-center">
//                     <small style={{ color: mode === 'dark' ? '#90caf9' : '#666' }}>
//                       {filteredChannels.length} of {res_get_array.length}
//                     </small>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Search and filter indicators */}
//             <div className="mt-2">
//               <small style={{ color: mode === 'dark' ? '#90caf9' : '#666' }}>
//                 {searchTerm && `Search: "${searchTerm}"`}
//                 {searchTerm && codeFilter !== 'all' && ' • '}
//                 {codeFilter !== 'all' && `Code: ${codeFilter}`}
//               </small>
//             </div>
//           </Box>

//           {/* ✅ التحكم في إظهار الأعمدة */}
//           <div style={{ marginBottom: '15px' }}>
//             {columns.map((col) => (
//               <label key={col.key} style={{ marginRight: '10px' }}>
//                 <input
//                   type="checkbox"
//                   checked={col.visible}
//                   onChange={() => {
//                     const newCols = [...columns];
//                     const targetIndex = newCols.findIndex((c) => c.key === col.key);
//                     newCols[targetIndex].visible = !newCols[targetIndex].visible;
//                     setColumns(newCols);
//                   }}
//                 />{' '}
//                 {col.label}
//               </label>
//             ))}
//           </div>

//           <div
//             style={{
//               overflowX: 'auto',
//               width: '100%',
//               marginTop: '20px',
//               borderRadius: '15px',
//             }}
//           >
//             <Table
//               size="sm"
//               responsive
//               style={{
//                 minWidth: isExtraSmallScreen ? '800px' : '100%',
//                 textAlign: 'center',
//                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                 backgroundColor: mode === 'dark' ? '#252525' : '#fff',
//                 borderSpacing: '0',
//                 borderRadius: '15px',
//                 overflow: 'hidden',
//               }}
//             >
//               <thead>
//                 <tr>
//                   {columns
//                     .map((col, index) => ({ ...col, index }))
//                     .filter((col) => col.visible)
//                     .map((col, visibleIndex) => (
//                       <th
//                         key={col.key}
//                         draggable
//                         onDragStart={(e) => e.dataTransfer.setData('dragColIndex', col.index)}
//                         onDragOver={(e) => e.preventDefault()}
//                         onDrop={(e) => {
//                           const dragIndex = parseInt(e.dataTransfer.getData('dragColIndex'));
//                           const dropIndex = col.index;

//                           if (dragIndex === dropIndex) return;

//                           const newColumns = [...columns];
//                           const draggedCol = newColumns.splice(dragIndex, 1)[0];
//                           const insertAt = newColumns.findIndex((c) => c.index === dropIndex);
//                           newColumns.splice(insertAt, 0, draggedCol);
//                           setColumns(newColumns);
//                         }}
//                         style={{
//                           position: 'relative',
//                           color: '#666',
//                           minWidth: `${col.width}px`,
//                           maxWidth: `${col.width}px`,
//                           whiteSpace: 'nowrap',
//                         }}
//                       >
//                         {col.label}
//                         <div
//                           onMouseDown={(e) =>
//                             startResizing(
//                               e,
//                               columns.findIndex((c) => c.key === col.key),
//                             )
//                           }
//                           style={{
//                             position: 'absolute',
//                             right: 0,
//                             top: 0,
//                             height: '100%',
//                             width: '5px',
//                             cursor: 'col-resize',
//                             borderBottom: mode === 'dark' ? '1px solid #90caf9' : '1px solid #666',
//                           }}
//                         />
//                       </th>
//                     ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={columns.filter((col) => col.visible).length}>Loading...</td>
//                   </tr>
//                 ) : filteredChannels?.length ? (
//                   filteredChannels.map((item, idx) => (
//                     <tr key={idx}>
//                       {columns
//                         .filter((col) => col.visible)
//                         .map((col) => {
//                           switch (col.key) {
//                             case 'copyId':
//                               return (
//                                 <td key={col.key}>
//                                   <CopyToClipboard onCopy={handleCopy} text={item._id}>
//                                     <div>
//                                       <ContentCopyIcon style={{ color: '#102dff' }} />
//                                     </div>
//                                   </CopyToClipboard>
//                                   <Snackbar open={open} autoHideDuration={2000}>
//                                     <Alert severity="success">Copy Done</Alert>
//                                   </Snackbar>
//                                 </td>
//                               );
//                             case 'name':
//                               return (
//                                 <td key={col.key} style={{ color: '#666' }}>
//                                   {item?.name}
//                                 </td>
//                               );
//                             case 'code':
//                               return (
//                                 <td key={col.key} style={{ color: '#666' }}>
//                                   {item?.code}
//                                 </td>
//                               );
//                             case 'date':
//                               return (
//                                 <td key={col.key} style={{ color: '#666' }}>
//                                   {item?.createdAt
//                                     ? moment(item?.createdAt).format('DD/MM/YYYY h:mm A')
//                                     : null}
//                                 </td>
//                               );
//                             case 'actions':
//                               return (
//                                 <td key={col.key}>
//                                   <ChannelActions channal={item} allchannals={run} />
//                                 </td>
//                               );
//                             default:
//                               return null;
//                           }
//                         })}
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan={columns.filter((col) => col.visible).length}
//                       style={{ textAlign: 'center', color: 'gray' }}
//                     >
//                       {searchTerm || codeFilter !== 'all'
//                         ? 'No channels found matching your filters'
//                         : 'No Data Found'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };



















// 20-5-2026
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
import { ChannelActions } from './ChannelActions';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconWifi    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>;
const IconCode    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>;
const IconTrend   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconChevron = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconX       = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

/* ─── Searchable Select ──────────────────────────────────────────────────── */
const SearchableSelect = ({ value, onChange, options, placeholder = 'All', isDark }) => {
  const [open,    setOpen]    = useState(false);
  const [searchQ, setSearchQ] = useState('');
  const wrapRef               = useRef(null);

  const filteredOpts = options.filter((o) =>
    o.label.toLowerCase().includes(searchQ.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = options.find((o) => o.value === value);

  return (
    <div ref={wrapRef} style={{ position: 'relative' }}>
      {/* Trigger */}
      <div
        onClick={() => { setOpen(!open); setSearchQ(''); }}
        style={{
          width: '100%', padding: '8px 12px', borderRadius: '8px', fontSize: '13px',
          border: `1px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
          backgroundColor: isDark ? '#151827' : '#f8fafc',
          color: value === 'all' ? (isDark ? '#6b7280' : '#94a3b8') : (isDark ? '#e5e7eb' : '#1f2937'),
          fontFamily: "'DM Sans', sans-serif", cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          boxSizing: 'border-box', userSelect: 'none',
        }}
      >
        <span>{selected?.label || placeholder}</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {value !== 'all' && (
            <span
              onClick={(e) => { e.stopPropagation(); onChange('all'); setOpen(false); }}
              style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', padding: '1px' }}
            >
              <IconX />
            </span>
          )}
          <span style={{
            display: 'flex', color: isDark ? '#6b7280' : '#94a3b8',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s',
          }}>
            <IconChevron />
          </span>
        </span>
      </div>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 9999,
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
          borderRadius: '10px', overflow: 'hidden',
          boxShadow: isDark ? '0 12px 40px rgba(0,0,0,0.5)' : '0 8px 30px rgba(0,0,0,0.12)',
        }}>
          {/* Search inside dropdown */}
          <div style={{ position: 'relative' }}>
            <span style={{
              position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
              color: isDark ? '#6b7280' : '#94a3b8', display: 'flex', pointerEvents: 'none',
            }}>
              <IconSearch />
            </span>
            <input
              autoFocus
              placeholder="Search…"
              value={searchQ}
              onChange={(e) => setSearchQ(e.target.value)}
              style={{
                width: '100%', padding: '10px 12px 10px 34px', fontSize: '13px',
                outline: 'none', border: 'none',
                borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
                backgroundColor: isDark ? '#151827' : '#f8fafc',
                color: isDark ? '#e5e7eb' : '#1f2937',
                fontFamily: "'DM Sans', sans-serif", boxSizing: 'border-box',
              }}
            />
          </div>

          {/* Options */}
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filteredOpts.length === 0 ? (
              <div style={{ padding: '12px', fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', textAlign: 'center' }}>
                No results
              </div>
            ) : (
              filteredOpts.map((o) => (
                <div
                  key={o.value}
                  onClick={() => { onChange(o.value); setOpen(false); setSearchQ(''); }}
                  style={{
                    padding: '9px 14px', fontSize: '13px', cursor: 'pointer',
                    backgroundColor: o.value === value
                      ? (isDark ? 'rgba(37,99,235,0.15)' : 'rgba(37,99,235,0.07)')
                      : 'transparent',
                    color: o.value === value
                      ? (isDark ? '#93c5fd' : '#1d4ed8')
                      : (isDark ? '#e5e7eb' : '#1f2937'),
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                  onMouseEnter={(e) => {
                    if (o.value !== value)
                      e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)';
                  }}
                  onMouseLeave={(e) => {
                    if (o.value !== value) e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  {o.label}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const ChannelTable = () => {
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const mode         = theme.palette.mode;
  const isDark       = mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [loading,      setLoading]      = useState(true);
  const [userlogin,    setUserlogin]    = useState(null);
  const [searchTerm,   setSearchTerm]   = useState('');
  const [codeFilter,   setCodeFilter]   = useState('all');
  const [showFilter,   setShowFilter]   = useState(false);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  const run = async () => {
    setLoading(true);
    await dispatch(GetAllchannalData());
    setLoading(false);
  };
  useEffect(() => { run(); }, [dispatch]);

  const res_Get_All = useSelector((state) => state.AllChannalRoot.channal);
  const allChannels = Array.isArray(res_Get_All?.data) ? res_Get_All.data : [];
  const uniqueCodes = [...new Set(allChannels.map((c) => c.code).filter(Boolean))];

  const codeOptions = [
    { value: 'all', label: 'All Codes' },
    ...uniqueCodes.map((c) => ({ value: c, label: c })),
  ];

  /* ── filter ── */
  const filtered = allChannels.filter((ch) => {
    const q = searchTerm.toLowerCase();
    const matchSearch = !q || ch.name?.toLowerCase().includes(q) || ch.code?.toLowerCase().includes(q);
    const matchCode   = codeFilter === 'all' || ch.code?.toLowerCase() === codeFilter.toLowerCase();
    return matchSearch && matchCode;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  /* ── stats ── */
  const newestChannel = allChannels.length
    ? allChannels.reduce((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? a : b)
    : null;

  const homeLink =
    userlogin?.data?.role === 'Admin'      ? '/AllLeadsForAdmin'
  : userlogin?.data?.role === 'Marketer'   ? '/ALLLeadsForMarketer'
  : userlogin?.data?.role === 'Accountant' ? '/LeadsForAccountant'
  : '/Dashboard';

  const clearFilters = () => { setSearchTerm(''); setCodeFilter('all'); setPage(1); };

  /* ── page numbers ── */
  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4)                   pages.push(1, 2, 3, 4, 5, '...', totalPages);
    else if (page >= totalPages - 3) pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    else                             pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    return pages;
  };

  const filterLabel = {
    fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em',
    textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8',
    marginBottom: '5px', display: 'block',
  };

  /* ─── render ─── */
  return (
    <>
      {/* ✅ يبدأ من بعد الـ sidebar مباشرة — position fixed */}
      <div style={{
        position: 'fixed',
        top: '50px',
        left: sidebarWidth,
        right: 0,
        bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: isDark ? '#0f1117' : '#f0f2f5',
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
      }}>

        {/* ── Breadcrumb ── */}
        <div style={{
          padding: '14px 28px', flexShrink: 0,
          backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
          display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
        }}>
          <Link to={homeLink} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
            Home
          </Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Channels</span>
        </div>

        {/* ── Scrollable body ── */}
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>

          {/* Stats */}
          <section className="ap-stats" style={{ padding: '24px 28px 0', flexShrink: 0 }}>
            <div className="ap-stat-card light">
              <div>
                <div className="ap-stat-label">TOTAL CHANNELS</div>
                <div className="ap-stat-value">{allChannels.length}</div>
                <div className="ap-stat-badge green">↑ Active in system</div>
              </div>
              <div className="ap-stat-icon light-icon"><IconWifi /></div>
            </div>

            <div className="ap-stat-card light">
              <div>
                <div className="ap-stat-label">UNIQUE CODES</div>
                <div className="ap-stat-value">{uniqueCodes.length}</div>
                <div className="ap-stat-badge green">Distinct codes</div>
              </div>
              <div className="ap-stat-icon light-icon"><IconCode /></div>
            </div>

            <div className="ap-stat-card dark-card">
              <div>
                <div className="ap-stat-label white">LATEST CHANNEL</div>
                <div className="ap-stat-value white" style={{ fontSize: 18, marginTop: 4 }}>
                  {newestChannel?.name || '—'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                  <span className="ap-badge-pill">MOST RECENT</span>
                  <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                    {newestChannel ? moment(newestChannel.createdAt).format('MMM DD, YYYY') : ''}
                  </span>
                </div>
              </div>
              <div className="ap-stat-icon dark-icon"><IconTrend /></div>
            </div>
          </section>

          {/* Table Section */}
          <section
            className="ap-table-section"
            style={{ margin: '24px 28px', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}
          >
            {/* header */}
            <div className="ap-table-header" style={{ flexShrink: 0 }}>
              <div>
                <div className="ap-table-title-label">MARKETING</div>
                <div className="ap-table-title">CHANNELS</div>
              </div>
              <div className="ap-table-actions">
                <div className="ap-search-inline">
                  <IconSearch />
                  <input
                    placeholder="Search by name or code…"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                  />
                </div>
                <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                  <IconFilter /> Filter
                </button>
                <Link to="/channal/addchannal" style={{ textDecoration: 'none' }}>
                  <button className="ap-create-btn"><IconPlus /> Add Channel</button>
                </Link>
              </div>
            </div>

            {/* Filter Row */}
            {showFilter && (
              <div style={{
                flexShrink: 0, padding: '16px 20px',
                backgroundColor: isDark ? '#161929' : '#f8fafc',
                border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
                borderRadius: '12px', marginBottom: '12px',
              }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px' }}>
                  <div>
                    <label style={filterLabel}>Filter by Code</label>
                    <SearchableSelect
                      value={codeFilter}
                      onChange={(v) => { setCodeFilter(v); setPage(1); }}
                      options={codeOptions}
                      placeholder="All Codes"
                      isDark={isDark}
                    />
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px' }}>
                  <span style={{ fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>
                    Showing{' '}
                    <strong style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{filtered.length}</strong>
                    {' '}of{' '}
                    <strong style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{allChannels.length}</strong> channels
                  </span>
                  <button className="ap-clear-btn" onClick={clearFilters}>Clear All</button>
                </div>
              </div>
            )}

            {/* Table */}
            <div className="ap-table-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
              <table className="ap-table">
                <thead>
                  <tr>
                    <th style={{ width: 40, position: 'sticky', top: 0, zIndex: 2, background: isDark ? '#1a1a2e' : '#fff' }}>
                      <input type="checkbox" className="ap-checkbox" />
                    </th>
                    <th style={{ position: 'sticky', top: 0, zIndex: 2, background: isDark ? '#1a1a2e' : '#fff' }}>CHANNEL NAME</th>
                    <th style={{ position: 'sticky', top: 0, zIndex: 2, background: isDark ? '#1a1a2e' : '#fff' }}>CODE</th>
                    <th style={{ position: 'sticky', top: 0, zIndex: 2, background: isDark ? '#1a1a2e' : '#fff' }}>CREATED DATE</th>
                    <th style={{ position: 'sticky', top: 0, zIndex: 2, background: isDark ? '#1a1a2e' : '#fff' }}>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan={5} className="ap-empty"><div className="ap-spinner" /><span>Loading channels…</span></td></tr>
                  ) : pageItems.length === 0 ? (
                    <tr><td colSpan={5} className="ap-empty"><IconSearch /><p>{searchTerm || codeFilter !== 'all' ? 'No channels match your filters' : 'No channels found'}</p></td></tr>
                  ) : (
                    pageItems.map((item, i) => (
                      <tr key={item._id || i} className="ap-row">
                        <td><input type="checkbox" className="ap-checkbox" /></td>
                        <td>
                          <div className="ap-project-cell">
                            <div className="ap-project-thumb">{item.name?.slice(0, 2).toUpperCase() || 'CH'}</div>
                            <span className="ap-project-name">{item.name || '—'}</span>
                          </div>
                        </td>
                        <td>
                          {item.code ? (
                            <span style={{
                              display: 'inline-flex', alignItems: 'center',
                              padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 600,
                              backgroundColor: isDark ? 'rgba(99,102,241,0.12)' : 'rgba(99,102,241,0.08)',
                              color: isDark ? '#a5b4fc' : '#4f46e5',
                              border: `1px solid ${isDark ? 'rgba(99,102,241,0.25)' : 'rgba(99,102,241,0.2)'}`,
                            }}>
                              {item.code}
                            </span>
                          ) : '—'}
                        </td>
                        <td className="ap-cell-muted" style={{ fontSize: 13 }}>
                          {item.createdAt ? moment(item.createdAt).format('MMM DD, YYYY') : '—'}
                        </td>
                        <td>
                          <div className="ap-actions">
                            <CopyToClipboard
                              text={item._id}
                              onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}
                            >
                              <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                            </CopyToClipboard>
                            <ChannelActions channal={item} allchannals={run} />
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {filtered.length > 0 && (
              <div
                className="ap-pagination"
                style={{
                  flexShrink: 0,
                  backgroundColor: isDark ? '#1a1a2e' : '#ffffff',
                  borderTop: `1px solid ${isDark ? '#2a2a45' : '#e8eaf0'}`,
                  boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
                }}
              >
                <div className="ap-pagination-info">
                  <span>Items per page:</span>
                  <select
                    className="ap-page-select"
                    value={itemsPerPage}
                    onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
                  >
                    {[5, 10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                  <span>
                    Showing <strong>{(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, filtered.length)}</strong>
                    {' '}of <strong>{filtered.length}</strong> channels
                  </span>
                </div>
                <div className="ap-pagination-btns">
                  <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page === 1}>⟨|</button>
                  <button className="ap-pag-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>
                  {buildPageNumbers().map((n, idx) =>
                    n === '...'
                      ? <span key={`e-${idx}`} className="ap-pag-ellipsis">…</span>
                      : <button key={n} className={`ap-pag-btn ${page === n ? 'active' : ''}`} onClick={() => setPage(n)}>{n}</button>
                  )}
                  <button className="ap-pag-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
                  <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>|⟩</button>
                </div>
              </div>
            )}
          </section>

          {/* Footer */}
          <footer className="ap-footer" style={{ padding: '16px 28px', flexShrink: 0 }}>
            <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
          </footer>
        </div>
      </div>

      <Snackbar open={copyOpen} autoHideDuration={2000} onClose={() => setCopyOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};